import React from 'react';
import classNames from 'classnames';
import { makeStyles, DialogContent } from "../../../../index";
import { useTranslation } from "../../../../hooks/useTranslation";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        flex: '0 0 auto',
    },
    count: {
        marginLeft: theme.spacing(1),
        '$exceeded &': {
            color: theme.palette.error.main,
        },
    },
    exceeded: {},
}); });
export var UserSelectDialogSelectedInfo = function (props) {
    var _a;
    var limit = props.limit, isExceedLimit = props.isExceedLimit, selectedUsersCount = props.selectedUsersCount, organizations = props.organizations;
    var t = useTranslation().t;
    var classes = useStyles();
    var className = classNames(classes.root, (_a = {},
        _a[classes.exceeded] = isExceedLimit,
        _a));
    var hasLimit = limit != null;
    var selectedOrganizationsMessage = organizations
        .map(function (organization) { return organization.fullName + " (" + organization.count + ")"; })
        .join(', ');
    return (React.createElement(DialogContent, { className: className },
        React.createElement("div", null,
            React.createElement("span", null, t('選んだユーザー')),
            hasLimit && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: classes.count }, selectedUsersCount),
                React.createElement("span", null, "/"),
                React.createElement("span", null, limit)))),
        React.createElement("div", null, selectedOrganizationsMessage)));
};
